import { CustomAxios } from "@shared/api/axiosClient";

import type { Schemas } from "@shared/api/types";

export type PeopleCulture = Schemas["PeopleAndCultureDTO"];
export type CmsFile = Schemas["FileDTO"];
export type BenefitsCard = Schemas["BenefitsCardDTO"];

// Capa HTTP del dominio cms. Funciones puras: entran params, sale Promise<data>.
// La auth y el Accept-Language los adjunta el interceptor axios compartido.

// Payload del CMS de People & Culture: portadas, imágenes, tarjetas, links, etc.
export const getPeopleCulture = (): Promise<PeopleCulture> =>
  CustomAxios.get("cms/people-culture").then(({ data }) => data);

// Descarga un archivo del CMS como Blob para previsualizarlo en el navegador.
export const getCmsFileBlob = (fileId: string, extension: string): Promise<Blob> =>
  CustomAxios.get(`cms/file/${fileId}/${extension}`, { responseType: "blob" }).then(
    ({ data }) => data
  );

// Notifica al backend que el usuario ya vio la pantalla de People & Culture.
export const markPeopleCultureViewed = (): Promise<unknown> =>
  CustomAxios.get("user-setting").then(({ data }) => data);
